import React, { useState } from 'react';
import { Users, Calendar, DollarSign, BarChart3 } from 'lucide-react';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import PatientAnalytics from '../components/analytics/PatientAnalytics';
import AppointmentAnalytics from '../components/analytics/AppointmentAnalytics';
import FinanceAnalytics from '../components/finance/FinanceAnalytics';

const Analytics = () => {
  const [activeTab, setActiveTab] = useState('patients');

  const tabs = [
    { id: 'patients', label: 'Patient Analytics', icon: Users },
    { id: 'appointments', label: 'Appointment Analytics', icon: Calendar },
    { id: 'finance', label: 'Financial Analytics', icon: DollarSign }
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      
      <div className="flex">
        <Sidebar />
        
        <div className="flex-1 p-6 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6">
              <div className="flex items-center mb-2">
                <BarChart3 className="w-8 h-8 text-indigo-600 mr-3" />
                <h1 className="text-3xl font-bold text-gray-900">Analytics Dashboard</h1>
              </div>
              <p className="text-gray-600">Comprehensive insights into your clinic's performance</p>
            </div>

            {/* Tabs */}
            <div className="bg-white rounded-lg shadow-md mb-6 border border-gray-200">
              <div className="flex overflow-x-auto">
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex items-center px-6 py-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${
                        activeTab === tab.id
                          ? 'border-indigo-600 text-indigo-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <Icon className="w-5 h-5 mr-2" />
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Tab Content */}
            <div className="transition-all duration-200">
              {activeTab === 'patients' && <PatientAnalytics />}
              {activeTab === 'appointments' && <AppointmentAnalytics />}
              {activeTab === 'finance' && <FinanceAnalytics />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;